<!-- 名师工作室 -->
<template>
  <div class="teaching-studio">
    <img :src="require('@/assets/images/qxdataboard/tips.png')" class="teaching-studio-tips" alt="">
    <div class="teaching-studio-title">
      <div class="name">名师工作室</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="teacheing-number">
      <div class="teacheing-number-all">
        <div class="number">{{studioInfo.msgzsNum}}</div>
        <div class="name">区域共建名师工作室</div>
      </div>
      <div class="teacheing-number-apply">
        <div class="number">{{studioInfo.msgzsApplyNum}}</div>
        <div class="name">老师申请数</div>
      </div>
      <!-- <div class="teacheing-number-appoint">
        <div class="number">18</div>
        <div class="name">指定开通数</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {getPlatformMasterStudioStatAPI} from "@/service/api.js"
export default {
  name: 'teaching-studio',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    regionType:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    //学校id
    schoolId:{
      type:String,
      default:""
    }
  },
  data() {
      return {
        studioInfo:{}
      }
  },
  watch:{
    startTime(){
      this.getPlatformMasterStudioStat();
    },
    endTime(){
      this.getPlatformMasterStudioStat();
    },
    schoolId(){
      this.getPlatformMasterStudioStat();
    },
    address(){
      this.getPlatformMasterStudioStat();
    }
  },
  methods: {

    /**
     * @name 获取名师工作室统计
     */
    getPlatformMasterStudioStat(){
      let params = {
        regionId:this.regionId,
        startTime:this.startTime ? `${this.startTime} 00:00:00` : '',
        endTime:this.endTime ? `${this.endTime} 23:59:59` : '',
        schoolId:this.schoolId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformMasterStudioStatAPI(params).then((res)=>{
        this.studioInfo = res;
      }).catch((err)=>{})
    },
  },
  mounted() {
    //获取平台名师工作室统计
    this.getPlatformMasterStudioStat();
  }
}
</script>

<style lang="scss" scoped>
.teaching-studio{
  margin-top: 20px;
  background: url("~@/assets/images/qxdataboard/studio-bg.png") no-repeat ;
  background-size:100% auto;
  background-position-y: bottom;
  height: 160px;
  position: relative;
  .teaching-studio-tips{
    position: absolute;
    top:0;
    left: 0;
  }
  .teaching-studio-title{
    // color: #fff;
    // font-size: 18px;
    // font-family: Microsoft YaHei;
    // font-weight: 400;
    // color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .teacheing-number{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 15px;
    padding-bottom: 13px;
    
    .teacheing-number-all,
    .teacheing-number-apply,
    .teacheing-number-appoint{
      display: flex;
      flex-direction: column;
      align-items: center;
      .number{
        width:70px;
        height: 70px;
        border-radius: 50%;
        font-size: 32px;
        font-family: MaravaleExpanded;
        font-weight: normal;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        @font-face {
          font-family: MaravaleExpanded;
          src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
        }
      }
      .name{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C4D6F2;
        margin-top: 13px;
      }
    }
    .teacheing-number-all{
      .number{
        border: 1px solid #FFDF25;
          box-shadow: 0px 0px 10px #DAB256;
        background: linear-gradient(0deg, #DAB256 0%, rgba(193,80,96,0.14) 100%);
      }
    }
    .teacheing-number-apply{
      .number{
        border: 1px solid #3BC3FC;
        box-shadow: 0px 0px 10px #05D8DC;
        background: linear-gradient(0deg, #05D8DC 0%, rgba(54,121,163,0.16) 98%);
      }
    }
    .teacheing-number-appoint{
      .number{
        border: 1px solid #2B8FFF;
        box-shadow: 0px 0px 10px #08A9E9;
        background: linear-gradient(0deg, #08A9E9 0%, rgba(42,94,180,0.14) 100%);
      }
    }
  }
}
</style>